// extracted by mini-css-extract-plugin
export var container = "_3o-0";
export var error = "_3o-9";
export var label = "_3o-5";
export var light = "_3o-6";
export var md = "_3o-3";
export var sm = "_3o-2";
export var thin = "_3o-8";
export var thinBold = "_3o-7";
export var vertical = "_3o-4";
export var xs = "_3o-1";